<template>
    <el-dialog title="租仓方案" :visible.sync="visible" width="50%" :close-on-click-modal="false">
        <el-form class="artificial-dialog-container" :model="form" :rules="rules" label-width="110px" ref="applyForm">
            <el-form-item label="人工决策" prop="whBizType">
                <el-radio-group v-model="form.whBizType">
                    <el-radio :label="item.value" v-for="item in radioList" :key="item.value">
                        {{ item.label }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="租仓方案信息" prop="whMipBizInfo">
                <el-input
                    type="textarea"
                    placeholder="请输入租仓方案信息"
                    v-model="form.whMipBizInfo"
                    maxlength="5000"
                    :rows="12"
                    show-word-limit></el-input>
            </el-form-item>
            <div class="scheme-container">
                <h3 class="scheme-title">租仓方案管理要求</h3>
                <div>1、合同条款必须与业主已达成一致方可提交方案；</div>
                <div>2、方案中必须明确租期、租金、免租期、付款周期、保险条款、违约条款（含提前终止、减仓条款等）；</div>
                <div>3、新仓合同必须完成签订之后方可启动入仓，不得无合同运作；</div>
                <div>
                    4、必须线下评审后再提交流程，会议评审包括但不限于以下人员： 内部业务：流程审批人员+美的业务（王京）
                </div>
                <div>5、外部业务租仓方案必须上传业务准入审批通过流程链接，同时上传附件5：新业务准入测算模型。</div>
            </div>
        </el-form>
        <div slot="footer">
            <el-button @click="handleVisible(false)">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleSubmit">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api'
const defaultDesc = `1、规划背景：XXX（描述变更的原因及背景说明）；\n2、方案说明：XXX（规划方案描述，具体执行描述）；\n3、效益点：XXX（调整后带来的效益点有哪些，没有写无）；\n4、启动日期：XX月XX日                                达成日期：XX月XX日\n5、毛利差异：XXX万元/月，①收入变化：XXX万元/月；②成本差异：XXX万元/月（仓、干、配、装成本差异总和）；\n6、决策项说明：①XXX；②XXX；③XXX......；由XXX、XXX、XXX……评审决策通过，执行XXX规划方案。`
export default {
    name: 'Artificial-dialog',
    components: {},
    props: {
        loading: Boolean,
    },
    data() {
        return {
            params: {},
            form: {
                whMipBizInfo: defaultDesc,
                whBizType: '',
            },
            rules: {
                whBizType: [{ required: true, message: '请选择人工决策', trigger: 'blur' }],
                whMipBizInfo: [{ required: true, message: '请输入项目必填信息', trigger: 'blur' }],
            },
            dicData: {},
            radioList: [],
            visible: false,
        }
    },
    watch: {
        visible(val) {
            // 关闭弹窗
            if (!val) {
                this.params = {} // 清空初始化的传参
            }
        }
    },
    methods: {
        handleVisible(flag, params) {
            if (params) {
                this.params = params
            }
            if (!flag) {
                this.$refs['applyForm'].resetFields()
            }
            this.visible = !!flag
            this.getData()
        },
        getData() {
            // 数字字典转换
            //人工决策 字典 SRM_WH_BIZ_TYPE
            dictWithUrl('SRM_WH_BIZ_TYPE').then(res => {
                if (res && +res.code === 0) {
                    this.dicData = res.data
                    let radioList = []
                    if (this.dicData.SRM_WH_BIZ_TYPE) {
                        const SRM_WH_BIZ_TYPE = this.dicData.SRM_WH_BIZ_TYPE
                        for (const key in SRM_WH_BIZ_TYPE) {
                            if (Object.prototype.hasOwnProperty.call(SRM_WH_BIZ_TYPE, key)) {
                                const label = SRM_WH_BIZ_TYPE[key]
                                radioList.push({
                                    label,
                                    value: key,
                                })
                            }
                        }
                    }
                    this.radioList = radioList
                }
            })
        },
        handleSubmit() {
            this.$refs['applyForm'].validate(valid => {
                if (valid) {
                    if (this.form.whMipBizInfo === defaultDesc) {
                        this.$message.warning('请补充项目必填信息')
                        return false
                    }
                    let params = {
                        type: 'ArtificialDialog',
                        data: {
                            whBizType: this.form.whBizType,
                            whMipBizInfo: this.form.whMipBizInfo,
                        },
                    }
                    this.visible = false
                    if (this.params && this.params.submitType) {
                        this.$emit('handleSubmit', this.params.submitType, params)
                    } else {
                        this.$emit('handleSubmit', 'submit', params)
                    }
                } else {
                    return false
                }
            })
        },
    },
}
</script>

<style lang="less">
.artificial-dialog-container {
    .scheme-container {
        margin-left: 110px;
    }
    .scheme-title {
        font-weight: normal;
    }
    .el-form-item__label {
        font-size: 14px;
    }
}
</style>
